module.exports = __webpack_public_path__ + "media/images/common/search/icon-company-b72450a4c7de5c021e8800f85799c824.png";